<template>
  <div class="service-record-status">
    <div class="service-record-status__section">
      <div class="service-record-status__title-section">
        <div class="service-record-status__label">Status</div>
      </div>
      <div class="service-record-status__border" />
      <div class="service-record-status__content">
        <Tag
          :value="statusText"
          :icon="status === 'Completed' ? 'pi pi-check' : 'pi pi-clock'"
          :class="[
            'service-record-status__tag',
            {
              'service-record-status__tag--completed': status === 'Completed',
              'service-record-status__tag--pending': status === 'Pending',
            },
          ]"
        />
        <BaseButton
          v-if="props.canUpdateStatus && status === 'Pending'"
          text="Marker som fullført"
          variant="primary"
          size="xs"
          :uppercase="true"
          @click="handleMarkComplete"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Tag from "primevue/tag";
import BaseButton from "@/components/Base/BaseButton/BaseButton.vue";

interface Props {
  status: "Pending" | "Completed";
  statusText: string;
  canUpdateStatus?: boolean;
}

interface Emits {
  (e: "mark-complete"): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const handleMarkComplete = () => {
  emit("mark-complete");
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.service-record-status {
  margin-bottom: 1rem;

  &__section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;
  }

  &__title-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  &__label {
    font-size: $font-size-base;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    color: $color-primary;
    font-weight: 600;
  }

  &__border {
    align-self: stretch;
    position: relative;
    background-color: $color-primary-light;
    height: 1px;
  }

  &__content {
    display: flex;
    align-items: center;
    gap: 1rem;
    width: 100%;

    @media (max-width: $bp-sm) {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.75rem;
    }
  }

  &__tag {
    :deep(.p-tag) {
      color: $color-primary-darker !important;
    }

    &--completed {
      background-color: $color-success-light !important;
      color: $color-success-dark !important;
      border-color: $color-success !important;

      :deep(.p-tag-icon) {
        color: $color-success-dark !important;
      }
    }

    &--pending {
      background-color: $color-primary-lighter !important;
      color: $color-primary-darker !important;
      border-color: $color-primary !important;

      :deep(.p-tag-icon) {
        color: $color-primary-darker !important;
      }
    }
  }
}

:deep(.p-tag) {
  color: $color-primary-darker !important;
  background-color: $color-primary-pink-lighter !important;
}
</style>
